module.exports = __webpack_public_path__ + "img/family-8.bc01d5b9.jpg";